module.exports = __webpack_public_path__ + "hero.9c109dc6fbd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/pricing/hero.jpg
// module id = ./src/styles/marketing/pricing/hero.jpg
// module chunks = 21